import React from "react";
import styles from "./LabelGeneratorProgressBar.module.css";

const LabelGeneratorProgressBar = ({ steps, currentIndex }) => {

  //adjust positioning of text below the progress bar
  const getStepShiftClass = (index) => {
    switch (index) {
      case 0: return styles.shift_recipient_progress_bar_text;
      case 1: return styles.shift_sender_progress_bar_text;
      case 2: return styles.shift_dimensions_progress_bar_text;
      case 3: return styles.shift_confirmation_progress_bar_text;
      default: return "";
    }
  };

  return (
    <div className={styles.stepper_container}>
      {steps.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isActive = index === currentIndex;

        return (
          <div key={index} className={styles.step_wrapper}>
            <div className={`${styles.circle} ${isCompleted ? styles.completed : isActive ? styles.active : styles.upcoming}`}>
              {isCompleted ? (
                <span className={styles.checkmark}>✓</span>
              ) : isActive ? (
                <img src={`${process.env.PUBLIC_URL}/images/mail_truck.gif`} alt="Current Step" className={styles.active_step_image} />
              ) : (index + 1)}
            </div>
            {isActive && (
              <div className={`${styles.step_label} ${getStepShiftClass(index)}`} >
                {step.charAt(0).toUpperCase() + step.slice(1)}
              </div>
            )}
            {index < steps.length - 1 && (<div className={`${styles.line} ${index < currentIndex - 1 ? styles.line_completed : ""}`} /> )}
          </div>
        );
      })}
    </div>
  );
};

export default LabelGeneratorProgressBar;